<h2 mat-dialog-title> Nuevo contenedor</h2>
<mat-dialog-content>

  <form [formGroup]="form">
    <mat-form-field class='formField'>
      <mat-label>Matricula</mat-label>
      <input matInput placeholder="Matricula" formControlName="matricula" required>
    </mat-form-field>
    <mat-form-field class='formField'>
      <mat-label>Matricula Antigua</mat-label>
      <input matInput placeholder="Matricula Antigua" formControlName="matricula_old">
    </mat-form-field>
    <mat-form-field class='formField'>
      <mat-label>Medidas</mat-label>
      <input matInput placeholder="Medidas" formControlName="medidas">
    </mat-form-field>
    <mat-form-field class='formField'>
      <mat-label>Tipo</mat-label>
      <mat-select formControlName="tipo" required>
        <input placeholder="Buscar..." (keyup)="filterSelect_Tipos($event.target.value)" class="inputSelectSearch">
        @for (tipo of tiposSearch; track tipo) {
          <mat-option [value]="tipo.id">{{tipo.nombre}}</mat-option>
        }
      </mat-select>
      <mat-error>Debes seleccionar un tipo.</mat-error>
    </mat-form-field>
    <mat-form-field class='formField'>
      <mat-label>Observaciones</mat-label>
      <input matInput placeholder="Observaciones" formControlName="observaciones">
    </mat-form-field>
    <mat-form-field class='formField'>
      <mat-label>Estado</mat-label>
      <mat-select formControlName="estado" required>
        <mat-option value="stock">En Stock</mat-option>
        <mat-option value="cliente">En Cliente</mat-option>
        <mat-option value="maintenance">Mantenimiento</mat-option>
        <mat-option value="baja">Baja</mat-option>
      </mat-select>
      <mat-error>Debes seleccionar un estado.</mat-error>
    </mat-form-field>
  </form>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-button (click)="save()">Guardar</button>
</mat-dialog-actions>
